"use strict";

var cov_10g4dr898l = function () {
  var path = "/Volumes/Github-Projects/gitea-react-toolkit/src/components/organizations/Organizations.js";
  var hash = "0108a6e700b4e28d07faed4834c1ab8db5c53218";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/Github-Projects/gitea-react-toolkit/src/components/organizations/Organizations.js",
    statementMap: {
      "0": {
        start: {
          line: 18,
          column: 29
        },
        end: {
          line: 23,
          column: 3
        }
      },
      "1": {
        start: {
          line: 20,
          column: 6
        },
        end: {
          line: 20,
          column: 27
        }
      },
      "2": {
        start: {
          line: 25,
          column: 19
        },
        end: {
          line: 25,
          column: 21
        }
      },
      "3": {
        start: {
          line: 27,
          column: 2
        },
        end: {
          line: 57,
          column: 3
        }
      },
      "4": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 36,
          column: 7
        }
      },
      "5": {
        start: {
          line: 29,
          column: 6
        },
        end: {
          line: 35,
          column: 8
        }
      },
      "6": {
        start: {
          line: 37,
          column: 9
        },
        end: {
          line: 57,
          column: 3
        }
      },
      "7": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 47,
          column: 7
        }
      },
      "8": {
        start: {
          line: 39,
          column: 6
        },
        end: {
          line: 46,
          column: 8
        }
      },
      "9": {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 56,
          column: 6
        }
      },
      "10": {
        start: {
          line: 58,
          column: 2
        },
        end: {
          line: 58,
          column: 35
        }
      },
      "11": {
        start: {
          line: 61,
          column: 0
        },
        end: {
          line: 87,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "Organizations",
        decl: {
          start: {
            line: 6,
            column: 9
          },
          end: {
            line: 6,
            column: 22
          }
        },
        loc: {
          start: {
            line: 17,
            column: 3
          },
          end: {
            line: 59,
            column: 1
          }
        },
        line: 17
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 19,
            column: 4
          },
          end: {
            line: 19,
            column: 5
          }
        },
        loc: {
          start: {
            line: 19,
            column: 14
          },
          end: {
            line: 21,
            column: 5
          }
        },
        line: 19
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 28,
            column: 35
          },
          end: {
            line: 28,
            column: 36
          }
        },
        loc: {
          start: {
            line: 29,
            column: 6
          },
          end: {
            line: 35,
            column: 8
          }
        },
        line: 29
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 38,
            column: 26
          },
          end: {
            line: 38,
            column: 27
          }
        },
        loc: {
          start: {
            line: 39,
            column: 6
          },
          end: {
            line: 46,
            column: 8
          }
        },
        line: 39
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 8,
            column: 2
          },
          end: {
            line: 8,
            column: 19
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 8,
            column: 17
          },
          end: {
            line: 8,
            column: 19
          }
        }],
        line: 8
      },
      "1": {
        loc: {
          start: {
            line: 13,
            column: 12
          },
          end: {
            line: 16,
            column: 8
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 16,
            column: 6
          },
          end: {
            line: 16,
            column: 8
          }
        }],
        line: 13
      },
      "2": {
        loc: {
          start: {
            line: 14,
            column: 4
          },
          end: {
            line: 14,
            column: 37
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 14,
            column: 19
          },
          end: {
            line: 14,
            column: 37
          }
        }],
        line: 14
      },
      "3": {
        loc: {
          start: {
            line: 15,
            column: 4
          },
          end: {
            line: 15,
            column: 73
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 15,
            column: 21
          },
          end: {
            line: 15,
            column: 73
          }
        }],
        line: 15
      },
      "4": {
        loc: {
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 57,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 57,
            column: 3
          }
        }, {
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 57,
            column: 3
          }
        }],
        line: 27
      },
      "5": {
        loc: {
          start: {
            line: 27,
            column: 6
          },
          end: {
            line: 27,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 27,
            column: 6
          },
          end: {
            line: 27,
            column: 19
          }
        }, {
          start: {
            line: 27,
            column: 23
          },
          end: {
            line: 27,
            column: 47
          }
        }],
        line: 27
      },
      "6": {
        loc: {
          start: {
            line: 31,
            column: 18
          },
          end: {
            line: 31,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 31,
            column: 18
          },
          end: {
            line: 31,
            column: 30
          }
        }, {
          start: {
            line: 31,
            column: 34
          },
          end: {
            line: 31,
            column: 70
          }
        }],
        line: 31
      },
      "7": {
        loc: {
          start: {
            line: 37,
            column: 9
          },
          end: {
            line: 57,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 37,
            column: 9
          },
          end: {
            line: 57,
            column: 3
          }
        }, {
          start: {
            line: 37,
            column: 9
          },
          end: {
            line: 57,
            column: 3
          }
        }],
        line: 37
      },
      "8": {
        loc: {
          start: {
            line: 37,
            column: 13
          },
          end: {
            line: 37,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 37,
            column: 13
          },
          end: {
            line: 37,
            column: 17
          }
        }, {
          start: {
            line: 37,
            column: 21
          },
          end: {
            line: 37,
            column: 36
          }
        }],
        line: 37
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0],
      "3": [0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "0108a6e700b4e28d07faed4834c1ab8db5c53218"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _ = require("../");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function Organizations(_ref) {
  var url = _ref.url,
      _ref$organization = _ref.organization,
      organization = _ref$organization === void 0 ? (cov_10g4dr898l.b[0][0]++, {}) : _ref$organization,
      urls = _ref.urls,
      organizations = _ref.organizations,
      onOrganization = _ref.onOrganization,
      config = _ref.config,
      _ref$messages = _ref.messages;
  _ref$messages = _ref$messages === void 0 ? (cov_10g4dr898l.b[1][0]++, {}) : _ref$messages;
  var _ref$messages$primary = _ref$messages.primaryError,
      primaryError = _ref$messages$primary === void 0 ? (cov_10g4dr898l.b[2][0]++, 'No organizations') : _ref$messages$primary,
      _ref$messages$seconda = _ref$messages.secondaryError,
      secondaryError = _ref$messages$seconda === void 0 ? (cov_10g4dr898l.b[3][0]++, 'Please provide valid organization objects or urls.') : _ref$messages$seconda;
  cov_10g4dr898l.f[0]++;
  var updateOrganization = (cov_10g4dr898l.s[0]++, (0, _react.useCallback)(function (repo) {
    cov_10g4dr898l.f[1]++;
    cov_10g4dr898l.s[1]++;
    onOrganization(repo);
  }, [onOrganization]));
  var components = (cov_10g4dr898l.s[2]++, []);
  cov_10g4dr898l.s[3]++;

  if ((cov_10g4dr898l.b[5][0]++, organizations) && (cov_10g4dr898l.b[5][1]++, organizations.length > 0)) {
    cov_10g4dr898l.b[4][0]++;
    cov_10g4dr898l.s[4]++;
    components = organizations.map(function (_organization) {
      cov_10g4dr898l.f[2]++;
      cov_10g4dr898l.s[5]++;
      return /*#__PURE__*/_react.default.createElement(_.Organization, {
        key: _organization.id,
        selected: (cov_10g4dr898l.b[6][0]++, organization) && (cov_10g4dr898l.b[6][1]++, _organization.id === organization.id),
        organization: _organization,
        onOrganization: updateOrganization,
        config: config
      });
    });
  } else {
    cov_10g4dr898l.b[4][1]++;
    cov_10g4dr898l.s[6]++;

    if ((cov_10g4dr898l.b[8][0]++, urls) && (cov_10g4dr898l.b[8][1]++, urls.length > 0)) {
      cov_10g4dr898l.b[7][0]++;
      cov_10g4dr898l.s[7]++;
      components = urls.map(function (_url, index) {
        cov_10g4dr898l.f[3]++;
        cov_10g4dr898l.s[8]++;
        return /*#__PURE__*/_react.default.createElement(_.Organization, {
          selected: _url === url,
          key: index,
          url: _url,
          onOrganization: updateOrganization,
          config: config,
          messages: {
            primaryError: primaryError,
            secondaryError: secondaryError
          }
        });
      });
    } else {
      cov_10g4dr898l.b[7][1]++;
      cov_10g4dr898l.s[9]++;
      components = [/*#__PURE__*/_react.default.createElement(_.Organization, {
        key: 0,
        organization: organization,
        config: config,
        messages: {
          primaryError: primaryError,
          secondaryError: secondaryError
        }
      })];
    }
  }

  cov_10g4dr898l.s[10]++;
  return /*#__PURE__*/_react.default.createElement(_core.List, null, components);
}

cov_10g4dr898l.s[11]++;
Organizations.propTypes = {
  /** Url to get organization data, if organization data is not provided. */
  url: _propTypes.default.string,

  /** Urls array to get organization data, if organization data is not provided. */
  urls: _propTypes.default.array,

  /** Organizations data array to render, if urls not provided. */
  organizations: _propTypes.default.array,

  /** Function to call when organization is selected. */
  onOrganization: _propTypes.default.func.isRequired,

  /** Configuration required if paths are provided as URL. */
  config: _propTypes.default.shape({
    server: _propTypes.default.string.isRequired
  }),

  /** The currently selected organization */
  organization: _propTypes.default.shape({
    avatar_url: _propTypes.default.string.isRequired,
    description: _propTypes.default.string.isRequired,
    full_name: _propTypes.default.string.isRequired,
    id: _propTypes.default.number.isRequired,
    location: _propTypes.default.string.isRequired,
    username: _propTypes.default.string.isRequired,
    visibility: _propTypes.default.string.isRequired,
    website: _propTypes.default.string.isRequired
  }),
  messages: _propTypes.default.shape({
    primaryError: _propTypes.default.string,
    secondaryError: _propTypes.default.string
  })
};
var _default = Organizations;
exports.default = _default;